export default __webpack_public_path__ + "scripts/resources/assignments_chemv_en.json";